import { LEAD_FORM_ANCHOR_ID } from "./renderProps";

export const DEFAULT_CTA_LABEL = "Start a conversation";
export const DEFAULT_CTA_URL = `#${LEAD_FORM_ANCHOR_ID}`;

export function resolveCta(
  label: string | undefined,
  url: string | undefined,
  fallbackUrl = DEFAULT_CTA_URL,
) {
  return {
    label: label?.trim() || DEFAULT_CTA_LABEL,
    url: url?.trim() || fallbackUrl,
  };
}
